module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-3.0b43059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-3.jpg
// module id = F9A4
// module chunks = 1